import imgCertifyEdit from './imgs/certify-edit.png';
import imgSubmitSuccess from './imgs/submit-success.png';
import imgCertifyEditNormal from './imgs/certify-edit-normal.png';
import imgSubmitSuccessNormal from './imgs/submit-success-normal.png';
import imgPhoneEditNormal from './imgs/phone-edit-normal.png';
import imgPhoneEdit from './imgs/phone-edit.png';

export const STEP_LIST = [
    {
        title: '1.填写号码信息',
        imgNormal: imgPhoneEditNormal,
        img: imgPhoneEdit
    },
    {
        title: '2.填写证明信息',
        imgNormal: imgCertifyEditNormal,
        img: imgCertifyEdit
    },
    {
        title: '3.提交等待审核',
        imgNormal: imgSubmitSuccessNormal,
        img: imgSubmitSuccess
    }
];
export const QUESTION_OPTIONS = [
    {
        label: '空号',
        value: 1
    }, {
        label: '无法接通',
        value: 2
    }, {
        label: '非该企业/政府号码',
        value: 3
    },
    {
        label: '号码占用申诉',
        value: 5
    },
    {
        label: '其他',
        value: 4
    },
];
export const QUESTION_OPTIONS2 = [
    {
        label: '标记错误',
        value: 6
    }
];
export const IP_APPEAL_QUESTION_OPTIONS = [
    {
        label: '归属地',
        value: 1
    }, {
        label: '运营商',
        value: 2
    }, {
        label: '应用场景',
        value: 3
    },
    {
        label: '风控标签',
        value: 4
    },
    {
        label: '其他',
        value: 5
    },
];
export const VERIFY_OPTIONS = [
    {
        label: '已受理',
        value: 0,
    }, {
        label: '已处理',
        value: 1
    }
];

export const SOURCE_OPTIONS = {
    aladdin: 1,
    qifu: 2,
    afd: 3
};

export const FEEDBACK_TYPE = [1, 2, 3, 4];
export const OCCUPY_TYPE = [5];
export const MARK_TYPE = [6];

export const FEEDBACK_OTHER = 4;
export const BELONG_TYPE = [5, 6];

export const FEEDBACK_SPEC = [3, 4];

export const formateTypeList = (phone) => {
    if (phone) {
        if (phone.indexOf('12') === 0) {
            return [{
                value: 3,
                label: '政府'
            }];
        }
        if (
            phone.indexOf('400') === 0
            || phone.indexOf('800') === 0
            || phone.indexOf('95') === 0
            || phone.indexOf('96') === 0
            || phone.length < 7
        ) {
            return [{
                value: 2,
                label: '企业'
            },
            {
                value: 3,
                label: '政府'
            }];
        }
    }
    return [{
        value: 1,
        label: '个人'
    },
    {
        value: 2,
        label: '企业'
    },
    {
        value: 3,
        label: '政府'
    }];
};


export const appealTitle = {
    1: '号码标记申诉',
    2: '号码占用申诉'
};
export const appealSubTitle = {
    1: '号码被标记为骚扰、推销等类型，可申诉取消',
    2: '个人、企业、政府被占用，可申诉取消'
};
export const appealBannerClass = {
    1: 'appeal-banner',
    2: 'occupy-banner'
};
export const appealTypeEventTracking = {
    1: 'person', // 个人
    2: 'company', // 企业
    3: 'government' // 政府
};
export const rePhone = /^1[3456789]\d{9}$/;
export const isMobilePhone = function (value) {
    return /^1[3456789]\d{9}$/.test(value);
};

export const isTelephone = function (value) {
    return /^0\d{2,3}-?\d{5,8}$/.test(value)
        || /^[48]00(-?\d{3,4}){2}$/.test(value)
        || (/^\d{5,10}$/).test(value)
        || (/^[9]\d{4,12}$/).test(value);
};
export const getPhoneName = data => {
    if (!data) {
        return '';
    }
    const dataInfo = data?.list[0];
    let phoneName = '';
    switch (data.mode) {
        case 'customer':
            phoneName = dataInfo.key || dataInfo.title;
            break;
        case 'reports':
            phoneName = dataInfo.tag;
            break;
        case 'poi':
            phoneName = dataInfo.name;
            break;
    }
    return phoneName;
};

export const initialStateErr = {
    // 个人
    phoneErr: '',
    certErr: '',
    emailErr: '',
    emailCodeErr: '',
    phoneCodeErr: '',
    // 企业
    companyQualifyErr: '',
    companyNameErr: '',
    companyAddressErr: '',
    // 政府
    socialErr: '',
    nameGovErr: '',

    attributionTypeErr: '',
};

export const initialQuestionStateErr = {
    questionTypeErr: '',
};